import { useStaticQuery, graphql } from 'gatsby'

type CollectionCard = {
  image: string
  link: string
  title: string
  altText?: string
}

type HighlightedCard = {
  active: boolean
  image: string
  link: string
  title: string
  text: string
  altText?: string
}

type BoxCard = {
  image: string
  link: string
  title: string
  altText?: string
}

type GetUnmissableSectionData = {
  getCmsWithVersionId: {
    node: Array<{
      sections: Array<{
        data: {
          collectionCard: CollectionCard[]
          highlightedCard: HighlightedCard
          boxCards: BoxCard[]
        }
        name: string | null
      }>
    }>
  }
}

const UnmissableSectionQuery = graphql`
  query GetUnmissableSectionData {
    getCmsWithVersionId(
      versionId: "e93e7231-2511-47e1-98ca-7b64ea3a65c3"
      contentType: "global"
      pageId: "6c309b8f-e668-40f4-9104-6d681904384e"
    ) {
      node {
        sections {
          data
          name
        }
      }
    }
  }
`

export function useUnmissableSection() {
  const globalCmsData = useStaticQuery<GetUnmissableSectionData>(
    UnmissableSectionQuery
  )

  return globalCmsData?.getCmsWithVersionId?.node?.[0]?.sections?.filter(
    (section) => {
      return section.name === '[Header] Seção Imperdível'
    }
  )?.[0]?.data
}
